import axios from 'axios';
import Papa from 'papaparse';

// Nombres de columna aceptados en la sheet (en minúsculas, sin espacios extremos)
const COLUMNS = {
    code: ['code', 'sku', 'código', 'codigo'],
    description: ['description', 'art.name', 'producto', 'descripción', 'descripcion'],
    Unidad: ['unidad', 'unidad de medida', 'unid. medida'],
    price: ['price', 'precio con iva', 'precio'],
};

const normalizeProduct = (row) =>{
    const product = {};
    Object.entries(COLUMNS).forEach(([key, aliases]) =>{
        const column = Object.keys(row).find(col => aliases.includes(col.trim().toLowerCase()));
        product[key] = column ? (row[column] || '').trim() : '';
    });
    return product;
}

export const getProducts = async (URL) =>{
    return axios.get(URL, {responseType: 'blob'})
    .then( response =>{
        return new Promise((resolve, reject) =>{
            Papa.parse(response.data, {
                header:true,
                skipEmptyLines: true,
                complete: (results) => {
                    return resolve(results.data.map(normalizeProduct).filter(p => p.description !== ''))
                },
                error: error => reject(error.message)
            })
        })
    })
}

export const getLinks = async (URL) =>{
    return axios.get(URL, {responseType: 'blob'})
    .then( response =>{
        return new Promise((resolve, reject) =>{
            Papa.parse(response.data, {
                header:true,
                complete: (results) => {
                    return resolve(results.data[0])
                },
                error: error => reject(error.message)
            })
        })
    })
}